var chunkMapping = {
	"64": [
		642,
		1081,
		1656,
		1681,
		1760,
		2147,
		2617,
		2862,
		4686,
		6703,
		7736,
		8681,
		9255
	],
	"263": [
		8739,
		7598,
		8147,
		559,
		2710
	],
	"363": [
		111,
		1012,
		2591,
		2948,
		6317,
		7693,
		8520,
		8999
	],
	"381": [
		7381
	],
	"438": [
		205,
		568,
		1126,
		1930,
		3406,
		3542,
		4381,
		6155,
		6404,
		9267
	],
	"510": [
		1335,
		1561,
		1863,
		5828,
		6467,
		6966,
		6968,
		7122,
		8618,
		8726,
		9266,
		9300
	],
	"610": [
		137,
		848,
		4963,
		6586,
		8513,
		9283
	],
	"649": [
		828,
		2391,
		2777,
		3580,
		4064,
		5620,
		5894,
		6744,
		9518,
		9684
	],
	"773": [
		6344,
		5210,
		2733
	],
	"819": [
		385,
		1517,
		2470,
		5075,
		6561,
		6708,
		7970,
		8804,
		9050,
		9381,
		9583
	]
};
var idToExternalAndNameMapping = {
	"111": [
		"default",
		"./Badge",
		2719
	],
	"137": [
		"default",
		"./register",
		7883
	],
	"205": [
		"default",
		"./Drawer",
		2719
	],
	"385": [
		"default",
		"./PropertyList",
		4779
	],
	"559": [
		"default",
		"./Page",
		2719
	],
	"568": [
		"default",
		"./FiltersGroup",
		2719
	],
	"642": [
		"default",
		"./TimelineItem",
		2719
	],
	"828": [
		"default",
		"./UnboxingPageIntroduction",
		8230
	],
	"848": [
		"default",
		"./Request",
		1441
	],
	"1012": [
		"default",
		"./Col",
		2719
	],
	"1081": [
		"default",
		"./ListHeader",
		2719
	],
	"1126": [
		"default",
		"./StatusFilter",
		2719
	],
	"1335": [
		"default",
		"./Text",
		2719
	],
	"1517": [
		"default",
		"./InputNumber",
		2719
	],
	"1561": [
		"default",
		"./PropertySelect",
		4779
	],
	"1656": [
		"default",
		"./OverviewHeader",
		2719
	],
	"1681": [
		"default",
		"./Divider",
		2719
	],
	"1760": [
		"default",
		"./Statistic",
		2719
	],
	"1863": [
		"default",
		"./icons/Clock",
		2719
	],
	"1930": [
		"default",
		"./FiltersBar",
		2719
	],
	"2147": [
		"default",
		"./Menu",
		2719
	],
	"2391": [
		"default",
		"./UnboxingPageHeader",
		8230
	],
	"2470": [
		"default",
		"./EmptyStateConfig",
		2719
	],
	"2591": [
		"default",
		"./Tooltip",
		2719
	],
	"2617": [
		"default",
		"./TabPane",
		2719
	],
	"2710": [
		"default",
		"./Row",
		2719
	],
	"2733": [
		"default",
		"./icons/Warning",
		2719
	],
	"2777": [
		"default",
		"./Image",
		2719
	],
	"2862": [
		"default",
		"./Tabs",
		2719
	],
	"2948": [
		"default",
		"./Card",
		2719
	],
	"3406": [
		"default",
		"./icons/Delete",
		2719
	],
	"3542": [
		"default",
		"./Table",
		2719
	],
	"3580": [
		"default",
		"./UnboxingPageBody",
		8230
	],
	"4064": [
		"default",
		"./UnboxingPageIntegrationBanner",
		8230
	],
	"4381": [
		"default",
		"./EmptyStateFilters",
		2719
	],
	"4686": [
		"default",
		"./MenuItem",
		2719
	],
	"4963": [
		"default",
		"./History",
		1441
	],
	"5075": [
		"default",
		"./RowContainer",
		2719
	],
	"5210": [
		"default",
		"./Spin",
		2719
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		8230
	],
	"5828": [
		"default",
		"./SegmentTypes",
		4779
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		8230
	],
	"6155": [
		"default",
		"./StatusOption",
		2719
	],
	"6317": [
		"default",
		"./Modal",
		2719
	],
	"6344": [
		"default",
		"./CopyToClipboard",
		2719
	],
	"6404": [
		"default",
		"./EmptyStateData",
		2719
	],
	"6467": [
		"default",
		"./hooks",
		1441
	],
	"6561": [
		"default",
		"./FloatingContainer",
		2719
	],
	"6586": [
		"default",
		"./Tag",
		2719
	],
	"6703": [
		"default",
		"./Timeline",
		2719
	],
	"6708": [
		"default",
		"./Panel",
		2719
	],
	"6744": [
		"default",
		"./UnboxingPage",
		8230
	],
	"6966": [
		"default",
		"./CatalogTypes",
		4779
	],
	"6968": [
		"default",
		"./Form",
		2719
	],
	"7122": [
		"default",
		"./Switch",
		2719
	],
	"7381": [
		"default",
		"./cWrapper",
		1441
	],
	"7598": [
		"default",
		"./List",
		2719
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"7736": [
		"default",
		"./CardRow",
		2719
	],
	"7970": [
		"default",
		"./DynamicRows",
		2719
	],
	"8147": [
		"default",
		"./ListItem",
		2719
	],
	"8513": [
		"default",
		"./Icon",
		2719
	],
	"8520": [
		"default",
		"./Selectors",
		8598
	],
	"8618": [
		"default",
		"./Button",
		2719
	],
	"8681": [
		"default",
		"./DashboardEmbed",
		5296
	],
	"8726": [
		"default",
		"./Input",
		2719
	],
	"8739": [
		"default",
		"./Collapse",
		2719
	],
	"8804": [
		"default",
		"./InlineSegmentationBuilder",
		4779
	],
	"8999": [
		"default",
		"./Message",
		2719
	],
	"9050": [
		"default",
		"./RouteLeavingGuard",
		2719
	],
	"9255": [
		"default",
		"./Skeleton",
		2719
	],
	"9266": [
		"default",
		"./Select",
		2719
	],
	"9267": [
		"default",
		"./icons/Edit",
		2719
	],
	"9283": [
		"default",
		"./unboxing-page",
		8230
	],
	"9300": [
		"default",
		"./Alert",
		2719
	],
	"9381": [
		"default",
		"./FormItem",
		2719
	],
	"9518": [
		"default",
		"./UnboxingPageDocumentation",
		8230
	],
	"9583": [
		"default",
		"./InputGroup",
		2719
	],
	"9684": [
		"default",
		"./UnboxingPageCrossSelling",
		8230
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}